/* Bundle products use the shared BF cart and discount controller. */
(() => {
  if (customElements.get('bf-bundles') || !window.BFOfferElement) return;
  class BFBundles extends window.BFOfferElement {
    connectedCallback() {
      super.connectedCallback();
      this.track = this.querySelector('[data-track]');
      this.previous = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      const { signal } = this.lifecycle;
      this.previous.addEventListener('click', () => this.move(-1), { signal });
      this.next.addEventListener('click', () => this.move(1), { signal });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') this.scroll(event.key === 'Home' ? 0 : this.track.scrollWidth);
        else this.move(event.key === 'ArrowLeft' ? -1 : 1);
      }, { signal });
      document.addEventListener('shopify:block:select', (event) => {
        const item = [...this.track.children].find((child) => child.dataset.blockId === event.detail?.blockId);
        if (item) this.scroll(item.offsetLeft - this.track.firstElementChild.offsetLeft, true);
      }, { signal });
      this.resizeObserver = new ResizeObserver(() => this.layout());
      this.resizeObserver.observe(this.track);
      this.layout();
    }

    layout() {
      const fits = this.track.scrollWidth <= this.track.clientWidth + 2;
      this.previous.hidden = fits;
      this.next.hidden = fits;
    }

    scroll(left, instant = false) {
      this.track.scrollTo({ left, behavior: instant || window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }

    move(direction) {
      const max = this.track.scrollWidth - this.track.clientWidth;
      if (max <= 2) return;
      const first = this.track.firstElementChild;
      const step = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(this.track).columnGap) || 0);
      const position = this.track.scrollLeft;
      const next = direction > 0 && position >= max - 2 ? 0 : direction < 0 && position <= 2 ? max : Math.max(0, Math.min(max, position + direction * step));
      this.scroll(next);
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      super.disconnectedCallback();
    }
  }
  customElements.define('bf-bundles', BFBundles);
})();
